import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  public tokenId = '';

  constructor(
    private title: Title,
    private router: Router
  ) { }

  ngOnInit() {
    this.setTitle();
  }

  setTitle() {
    this.title.setTitle('Pague.lá | 404');
  }

  submit(e) {
    e.preventDefault();
    this.router.navigate(['/checkout'], { queryParams: { tokenId: this.tokenId } });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/checkout/components/not-found/not-found.component.ts